import _ from 'lodash';
import utils from 'utils/utils';
import moment from 'moment';
import { formatDate } from 'utils/formatDate';
import numeral from 'numeral';

const formatShortDate = (date) => {
  return formatDate(date, { hasDayPrefix: false }, 'D MMM YYYY');
};

export const formatPrice = (number) => {
  return numeral(number).format('0,0.00');
};

export const formatNumber = (number, format = '0,0.00') => {
  return numeral(number).format(format);
};

export const formatRating = (rating) => {
  if (rating) {
    const rat = parseFloat(rating);
    return rat.toFixed(1);
  }
  return '0.0';
};

export const formatPvCode = (withdrawal) => {
  if (withdrawal && withdrawal.pvCode >= 0) {
    const date = moment(withdrawal.approvedDate);
    console.log(`SPV${date.format('YYYYMM')}-${utils.FormatNumberLength(withdrawal.pvCode, 4)}`);
    return `SPV${date.format('YYYYMM')}-${utils.FormatNumberLength(withdrawal.pvCode, 4)}`;
  }
  return '';
};

export const getOrganicRevenue = (revenueSummary) => {
  if (revenueSummary.organicRevenue) return revenueSummary.organicRevenue;
  if (!revenueSummary || !revenueSummary.discountList) return 0;
  const discount = revenueSummary.discountList.reduce((result, discountItem) => {
    return result + discountItem.amount;
  }, 0);
  const additional = revenueSummary.additionalList.reduce((result, additionalItem) => {
    return result + additionalItem.amount;
  }, 0);
  const organicRevenue = revenueSummary.classRevenue - discount + additional;
  return organicRevenue;
};

const pad = (n, width) => {
  const z = '0';
  n = n + '';
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
};

export const formatThaiDuration = (duration) => {
  const minutes = Math.floor(duration / 60);
  const minuteString = minutes ? `${minutes}` : '0';
  const seconds = duration % 60;
  return `${pad(minuteString, 2)}:${pad(seconds, 2)} นาที`;
};

export const formatLongThaiDuration = (duration) => {
  const hours = Math.floor(duration / 3600);
  const hourString = hours ? `${hours} ชั่วโมง ` : '';
  const minutes = Math.floor(duration / 60) % 60;
  const minuteString = hours || minutes ? `${pad(minutes, 2)} นาที ` : '';
  return `${hourString}${minuteString}`;
};

export default {};
